export default {
      id: "barre-usage",
      viewBox: "0 0 320 12",
      url: "../dist/images/" + "sprite.svg#barre-usage",
      toString: function () {
        return this.url;
      }
    }